import { defaultDataLoadingState } from './reducers.js';


export const getRoot = state => state.get('ui') || state;

export const getMessages = state => getRoot(state).get('messages');

export const isSidebarVisible = state => getRoot(state).get('isSidebarVisible');

export const getNavbarHeight = state => getRoot(state).get('navbarHeight');

// DataLoading things
const getDataLoading = name => state => getRoot(state).getIn(['dataLoading', name]) || defaultDataLoadingState;

export const dataLoading = {
    getData: name => state => getDataLoading(name)(state).get('data'),
    isLoading: name => state => getDataLoading(name)(state).get('isLoading'),
    isLoadingFail: name => state => getDataLoading(name)(state).get('isLoadingFail'),
};
